//import { useState } from 'react';
import {
    Container,
    Title,
    BodyText,
    CenterContainer,
    LinkText,
    CardIconContainer,
    Image
} from './styles/ServiceCardStyles';

// Usar rutas absolutas desde la carpeta public
const CommunicationsIcons = '/icons/CommunicationsIcons.png';
const DesarrolloIcon = '/icons/DesarrolloIcon.png';
const EnergyIcons = '/icons/EnergyIcons.png';
const FlyIcon = '/icons/FlyIcon.png';
const InvestIcon = '/icons/InvestIcon.png';
const iconsProfitIcon = '/icons/icons8-profit.svg';
const InvestCoinIcon = '/icons/icons8-investment-80.png';

function ServiceCard({ title, bodyText, onRequestPress, requestCustomTitle, cardNumber = 0 }) {
    const iconsForCard = [
        FlyIcon,
        EnergyIcons,
        DesarrolloIcon,
        CommunicationsIcons,
        InvestIcon,
        iconsProfitIcon,
        InvestCoinIcon
    ];
    
    // Usar módulo para que el índice siempre esté dentro del rango del array
    const iconIndex = cardNumber % iconsForCard.length;
    const selectedIcon = iconsForCard[iconIndex] || InvestIcon;
    
    return (
        <Container>
            <CardIconContainer>
                <Image src={selectedIcon} />
            </CardIconContainer>
            <CenterContainer >
                <Title>{title}</Title>
                <BodyText>
                    {bodyText}
                </BodyText>
                <LinkText onClick={onRequestPress}>
                    {requestCustomTitle ? requestCustomTitle : "VER TRÁMITES"}
                </LinkText>
            </CenterContainer>
        </Container >
    );
}

export default ServiceCard;
